"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CookiesStorage = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var CookiesStorage = /*#__PURE__*/function () {
  function CookiesStorage() {
    (0, _classCallCheck2["default"])(this, CookiesStorage);
    (0, _defineProperty2["default"])(this, "storage", _jsCookie["default"]);
  }

  (0, _createClass2["default"])(CookiesStorage, [{
    key: "getItem",
    value: function getItem(key) {
      return this.storage.get(key);
    }
  }, {
    key: "setItem",
    value: function setItem(key, value, options) {
      this.storage.set(key, value, options || {});
    }
  }, {
    key: "deleteItem",
    value: function deleteItem(key, options) {
      this.storage.remove(key, options);
    }
  }]);
  return CookiesStorage;
}();

exports.CookiesStorage = CookiesStorage;

var _default = new CookiesStorage();

exports["default"] = _default;